import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface BenefitUsage {
  usageDate: string;
  benefit: string;
  branch: string;
  requestCreator: string;
  requestInvoice: string;
}

@Component({
  selector: "app-benefit-usage-history",
  templateUrl: "./benefit-usage-history.component.html",
  styleUrls: ["./benefit-usage-history.component.scss"],
})
export class BenefitUsageHistoryComponent {
  dataSource: BenefitUsage[] = [];

  constructor(private dialogRef: MatDialogRef<BenefitUsageHistoryComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
